export function combineSourceMedia(media?: string, when?: string) {
  if (media && when) return `${media} and ${when}`;
  return media || when;
}
